import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";

const getTableOrders = (company) => {
    const params = {};
    // In single-company mode we intentionally do NOT send the company param at all.
    if (company) {
        params.company = company;
    }

    return axios.get(`method/restaurant_management.api.get_floor_data`, { params });
};

export const useGetTableOrders = ({ company, disabled }) => {
    return useQuery(
        ["getTableOrdersData", company],
        async () => {
            const { data } = await getTableOrders(company);
            return data;
        },
        {
            // Keep previous floor data rendered while a background refetch runs.
            // This avoids "white screen" when navigating back to Tables or when realtime updates arrive.
            keepPreviousData: true,
            staleTime: 5 * 1000,
            cacheTime: 5 * 60 * 1000,
            refetchOnMount: false,
            refetchOnReconnect: true,
            refetchOnWindowFocus: false,
            enabled: !disabled,
        }
    );
};

export const useMoveOrderItems = () => {
    return useMutation(async ({ items, orderId, destinationTable, client }) => {
        const args = {
            items: items,
            destinationTable,
            client,
        };

        const params = {
            model: `Table Order`,
            name: orderId,
            method: `divide`,
            args: JSON.stringify(args),
        };
        const data = await axios.post(
            `method/frappe_helper.api.call`,
            params
        );

        return data;
    });
};

//move_table_orders
